import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/_layout/inventory/rental-contracts_/$id")({
  component: RentalContractDetailRoute,
});

import { ProtectedRoute } from "@/components/protected-route";
import { RentalContractDetailPage } from "@/components/inventory/RentalContractDetailPage";

function RentalContractDetailRoute() {
  const { id } = Route.useParams();
  // Same gate as the list page: RentalLeaseContractViewSet's read_permission
  // ("inventory.stock.view") covers retrieve too, with no
  // degrade-to-own-rows fallback.
  return (
    <ProtectedRoute requiredPermission="inventory.stock.view">
      <RentalContractDetailPage contractId={id} />
    </ProtectedRoute>
  );
}
